import React, { useState } from "react"
import MatSelectButtons from "./shared/MatSelectButtons";
import DOMPurify from 'dompurify'

const Section1 = ({products, select, setSelect, setStep, step, orders}) => {

  // const [prodImage, setProdImage] = useState('')
  const [prodDescr, setProdDescr] = useState('')
  const [prodPage, setProdPage] = useState('')
  const [prodHaveSubmat, setProdHaveSubmat] = useState(true)

  var selectedMaterial = -1

  function nextStep(step){
    let elem = document.querySelector('.matselect input:checked')
    let selectedMaterial = -1;
    if (elem !== null) selectedMaterial = parseInt(elem.value)

    if (selectedMaterial <= -1){
      alert(window.lang['s1']['select_mat'])
      return null
    }

    let submaterial = parseInt(elem.value);

    if (!prodHaveSubmat){
      var dataset;
      submaterial = 0;
      dataset = products[selectedMaterial].properties.submaterial[submaterial];
      let roll_length = parseInt(dataset.roll_length);
      if (isNaN(roll_length)) {roll_length = -1;}
      let newSelect = select
      select.material = selectedMaterial
      select.submaterial = submaterial
      select.cut = dataset.cut
      select.roll = dataset.roll
      select.roll_length = roll_length
      select.options[`${products[selectedMaterial].properties.submaterial[submaterial].name}`] = parseFloat(dataset.coef)
      setSelect(newSelect)
    }else{
      setSelect({...select, material: selectedMaterial});
    }
    setStep(1+step);
  }

  function updateProd(){
    var elem = document.querySelector('.matselect input:checked');

    if (elem !== null && parseInt(elem.value) >= 0){
      selectedMaterial = parseInt(elem.value);
      //elem.querySelector('option:first-child').disabled = true
    } else {
      // setProdImage('')
      setProdDescr('')
      console.log('shit happened !', elem.value);
      return;
    }

    /* update image */
    // if ((products[selectedMaterial].title_image !== 'false' || products[selectedMaterial].title_image === '-1')){
    //   setProdImage(products[selectedMaterial].title_image);
    // }else{
    //   setProdImage(document.location.origin+"/wp-content/themes/experon-ebusiness-child/images/not-pictured.png") // image plceholder path
    // }

    /* update description */
    if (selectedMaterial !== '-1'){
      setProdDescr(products[selectedMaterial].description);
    } else {
      setProdDescr(window.lang['s1']['select_mat']);
    }

    if (products[selectedMaterial].page_link !== null){
      setProdPage(products[selectedMaterial].page_link);
    }

    if (products[selectedMaterial].properties.submaterial.length === 1 ) {
      setProdHaveSubmat( false );
      setSelect({
        ...select,
        submaterial: 0
      })
    }else{
      setProdHaveSubmat( true );
      setSelect({
        ...select,
        submaterial: -1
      })
    }
  }

  function ToProductPage(){
    if (prodPage !== '' ){
      return(
        <a href={prodPage} target="_blank" rel="noreferrer" className="outerlink toProductPage" >{window.lang['s1']['link_to_mat']}</a>
      )
    }else{
      return null;
    }
  }

  function NextStep(){
    if (prodHaveSubmat){
      return (
        <button id="nextStep" className="btn btn-next" onClick={() => nextStep(1)}><span>{window.lang['s1']['btn_to_sumbat']}</span></button>
      )
    }else{
      return(
        <button id="nextStep" className="btn btn-next" onClick={() => nextStep(2)}><span>{window.lang['s1']['btn_to_sizes']}</span></button>
      )
    }
  }

  function ProdDescription(){
    if (prodDescr !== ''){
      return (<article className="prod-descr" dangerouslySetInnerHTML={{__html : DOMPurify.sanitize(prodDescr)}} />)
    } else {
      return (<article className="prod-descr">{window.lang['s1']['select_mat']}</article>)
    }
  }

  function ToCart(){
    if (orders){
      return <button className="btn btn-prev" onClick={() => goBack()} ><span>{window.lang['s1']['btn_to_cart']}</span></button>
    }else{
      return null
    }
  }

  function Material(item, index){

    return(
      <>
        <input key={index} type="radio" name="matselect" id={'mat-'+index} value={index} onChange={updateProd} /> 
        <label className="matselect-option" htmlFor={'mat-'+index} style={{backgroundImage : 'url('+item.title_image+')', order: item.index}}>
          <span>{item.name}</span>
        </label>
      </>
    )
  }

  function goBack(){
    setStep(0)
  }

  return(
    <>
      <div className="section_header">
        <h1>{window.lang['s1']['title']}</h1>
        <div className="step-btns">
          <ToCart />
          <NextStep />
        </div>
      </div>
      <p>{window.lang['s1']['note']}</p>
      <div className="matselect">
        {products.map((item, index) => Material(item,index) )}
      </div>

      <ProdDescription />

      <ToProductPage />
      <div className="step-btns">
          <ToCart />
          <NextStep />
      </div>

      <MatSelectButtons step={1}/>
    </>
  )
}

export default Section1

/*

  function ProdImg(){
    if (prodImage !== ''){
      return(<img className="prod-img" alt="material example" src={prodImage} />)
    }
    else
    {
      return (
        <div className="prod-img"></div>
      )
    }
  }


      <select id="product" onChange={updateProd}>
        <option key={-1} value={-1} defaultValue>Выберите Материал</option>
        {products.map((item, index) => {return(<option key={index} value={index}>{item.name}</option>)} )}
      </select>

      <div className="img-with-descr">
        <ProdImg />
        <ProdDescription />
      </div>


*/